import { Toaster } from 'sonner'

import { CompaniesDashboard } from './components/companies/CompaniesDashboard'
import { MissingConfiguration } from './components/layout/MissingConfiguration'
import { isSupabaseConfigured } from './lib/supabase'

export function App() {
  return (
    <>
      {isSupabaseConfigured ? <CompaniesDashboard /> : <MissingConfiguration />}
      <Toaster richColors position="top-right" closeButton />
    </>
  )
}
